import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const CurriculumDropdownWithCreate = ({ value, onChange }) => {
  const [curricula, setCurricula] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCurricula();
  }, []);

  const fetchCurricula = async () => {
    const res = await api.get('/curricula');
    setCurricula(res.data);
  };

  const handleCreate = async () => {
    if (!newName.trim()) return;
    setLoading(true);
    const res = await api.post('/curricula', { name: newName });
    setNewName('');
    setShowModal(false);
    await fetchCurricula();
    onChange(res.data._id);
    setLoading(false);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-semibold mb-1">Curriculum</label>
      <div className="flex gap-2 items-center">
        <select
          className="rounded px-3 py-2 bg-eduvibe-blue text-white focus:outline-none"
          value={value}
          onChange={e => onChange(e.target.value)}
        >
          <option value="">Select curriculum</option>
          {curricula.map(c => (
            <option key={c._id} value={c._id}>{c.name}</option>
          ))}
        </select>
        <button
          className="bg-eduvibe-green text-eduvibe-dark px-2 py-1 rounded hover:bg-eduvibe-green-dark font-bold text-lg"
          type="button"
          onClick={() => setShowModal(true)}
          title="Add curriculum"
        >+
        </button>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-eduvibe-blue p-6 rounded-lg min-w-[300px]">
            <h2 className="text-lg font-bold mb-2 text-white">Add Curriculum</h2>
            <input
              className="w-full px-3 py-2 rounded mb-3 bg-eduvibe-dark text-white"
              placeholder="Curriculum name"
              value={newName}
              onChange={e => setNewName(e.target.value)}
              autoFocus
              disabled={loading}
            />
            <div className="flex gap-2 justify-end">
              <button onClick={() => setShowModal(false)} className="px-3 py-1 rounded bg-gray-600 text-white">Cancel</button>
              <button onClick={handleCreate} disabled={loading} className="px-3 py-1 rounded bg-eduvibe-green text-eduvibe-dark font-semibold hover:bg-eduvibe-green-dark">Create</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurriculumDropdownWithCreate;
